import tippy from "tippy.js";

export function initSimpleTooltips(tooltipClass, options) {

    const simpleTooltips = document.querySelectorAll(tooltipClass);
    const readyToInitTooltips = [];
    const defaultOptions = {
        placement: "top",
        touch: false,
        maxWidth: 300,
        trigger: "mouseenter",
        theme: "light",
        arrow: true,
        ignoreAttributes: true,
        hideOnClick: true,
        allowHTML: true,
        onShow(instance) {
            if (window.mobileMedia) {
                instance.reference._tippy.props.placement = "top";
            }
        },
        onCreate(instance) {
            instance.setContent(instance.reference.dataset.announcing);
            if (tooltipClass !== ".js-custom-fancybox-action") {
                instance.reference.removeAttribute("data-announcing");
            }
        },
    }
    const tooltipOptions = defaultOptions;

    if (options) {
        Object.assign(tooltipOptions, options);
    }
    
    if (simpleTooltips && simpleTooltips.length > 0) {
        for (const tooltip of simpleTooltips) {
            if (tooltip.hasAttribute("data-announcing")) {
                readyToInitTooltips.push(tooltip);
            }
        }

        tippy(readyToInitTooltips, tooltipOptions);
    }
}
